import Select from "react-select";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import moment from "moment";
import Swal from "sweetalert2";
import {
  Container,
  Card,
  Form,
  Row,
  Col,
  ButtonGroup,
  Button,
} from "react-bootstrap";
import { getLeaveAwardsByEmployee } from "../../3.Store/LeaveAwardsSlice";
import { getALeaveProrates, resetList, updateList, updateLeaveProrates, updateEntitle } from "../../3.Store/LeaveProratedSlice";
import { ThreeDots } from 'react-loader-spinner';

const LeaveProratedForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const proratesList = useSelector(state => state.LeaveProratedSlice.proratesList) || {};
  const entitle = useSelector(state => state.LeaveProratedSlice.entitle) || {};
  const loading = useSelector(state => state.LeaveProratedSlice.loading);
  const { 
    prorate_date,
    created,
    leave_bf,
    leave_taken_this_year,
    current_leave_balance,
    prorated_leave_awarded,
    prorated_sickleave_awarded,
    prorated_medicalbenefit_awarded,
    new_leave_balance,
    deduction_required,
    prorate_type
  } = proratesList;
  const awardList = useSelector(state => state.LeaveAwardsSlice.awardList) || {};
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const employeeId = proratesList?.employee?.id;
  
  const getSearchParamsFromQuery = () => {
    const params = new URLSearchParams(location.search);
    const page = params.get('page');
    const years = params.get('years');
    return { page, years };
  };

  const { page, years } = getSearchParamsFromQuery();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (id) {
      dispatch(getALeaveProrates({ id }))
        .catch((err) => {
          console.error("Failed to fetch leave prorates:", err);
        });
    } else {
      dispatch(resetList());
    }
  }, [id]);

  useEffect(() => {
    if (employeeId) {
      dispatch(getLeaveAwardsByEmployee({ id: employeeId, year: years }))
        .catch((err) => {
          console.error("Failed to fetch leave awards:", err);
        });
    }
  }, [employeeId]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // useEffect(() => {
  //   const entity = {
  //     ...proratesList,
  //     // new_leave_balance: Number(current_leave_balance) - Math.abs(prorated_leave_awarded),
  //     new_leave_balance: Number(awardList.annual) - (Number(awardList.annual) - Math.abs(prorated_leave_awarded)) - Number(leave_taken_this_year) + Number(leave_bf),
  //   };
    
  //   console.log(entity);
  //   dispatch(updateList(entity)); 
  // }, [new_leave_balance]);

  useEffect(() => {
    const calculated_balance = 
      Number(awardList.annual) -
      (Number(awardList.annual) - Math.abs(prorated_leave_awarded)) -
      Number(leave_taken_this_year) +
      Number(leave_bf);
  
    const new_leave_balance = Math.max(calculated_balance, 0); // Set to 0 if negative
    const deduction_required = calculated_balance < 0 ? Math.abs(calculated_balance) : 0;
  
    const entity = {
      ...proratesList,
      new_leave_balance,
      deduction_required
    };
  
    console.log(entity);
    dispatch(updateList(entity)); 
  }, [new_leave_balance]);  

  const handleUpdate = (e) => {
    const entity = { ...proratesList, [e.target.name]: e.target.value };
    console.log(entity);
    dispatch(updateList(entity));
  };

  const handleUpdateProrated = (e) => {
    const { name, value } = e.target;

    const updatedValue = {
      ...proratesList,
      [name]: Number(value), // ensure numeric input
    };
    
    const proratedLeave = 
      name === "prorated_leave_awarded" 
        ? Number(value) 
        : Number(proratesList?.prorated_leave_awarded ?? 0);
    
    const entity = {
      ...updatedValue,
      new_leave_balance: (Number(awardList.annual) - (Number(awardList.annual) - Math.abs(proratedLeave)) - Number(leave_taken_this_year) + Number(leave_bf)),
    };
    
    console.log((Number(awardList.annual) - Math.abs(proratedLeave)));
    console.log(Number(leave_taken_this_year), Number(leave_bf));
    dispatch(updateList(entity));      
  };

  const handleBtnUpdate = () => {
    const updatedValues = {
      ...proratesList,
      // prorated_leave_awarded:
      //   proratesList.prorated_leave_awarded > 0
      //     ? proratesList.prorated_leave_awarded * -1
      //     : proratesList.prorated_leave_awarded,
  
      // prorated_sickleave_awarded:
      //   proratesList.prorated_sickleave_awarded > 0
      //     ? proratesList.prorated_sickleave_awarded * -1
      //     : proratesList.prorated_sickleave_awarded,
  
      // prorated_medicalbenefit_awarded:
      //   proratesList.prorated_medicalbenefit_awarded > 0
      //     ? proratesList.prorated_medicalbenefit_awarded * -1
      //     : proratesList.prorated_medicalbenefit_awarded,

      //   prorated_leave_awarded:
      //     prorate_type === -1
      //       ? -Math.abs(Number(awardList.annual) - Number(proratesList.prorated_leave_awarded))  // ensure negative
      //       : Math.abs(proratesList.prorated_leave_awarded), // ensure positive

      //   prorated_sickleave_awarded:
      //     prorate_type === -1
      //       ? -Math.abs(Number(awardList.sick) - Number(proratesList.prorated_sickleave_awarded))
      //       : Math.abs(proratesList.prorated_sickleave_awarded),

      //   prorated_medicalbenefit_awarded:
      //     prorate_type === -1
      //       ? -Math.abs(Number(awardList.medical) - Number(proratesList.prorated_medicalbenefit_awarded))
      //       : Math.abs(proratesList.prorated_medicalbenefit_awarded),
      // };
      
      prorated_leave_awarded:
        proratesList.prorated_leave_awarded < 0
          ? Math.abs(proratesList.prorated_leave_awarded)
          : proratesList.prorated_leave_awarded,

      prorated_sickleave_awarded:
        proratesList.prorated_sickleave_awarded < 0
          ? Math.abs(proratesList.prorated_sickleave_awarded)
          : proratesList.prorated_sickleave_awarded,

      prorated_medicalbenefit_awarded:
        proratesList.prorated_medicalbenefit_awarded < 0
          ? Math.abs(proratesList.prorated_medicalbenefit_awarded)
          : proratesList.prorated_medicalbenefit_awarded,
    };
  
    const entity = {
      ...updatedValues,
      prorate_date: moment(awardList.effective_date).format("YYYY-MM-DD"),
    };
  
    dispatch(updateLeaveProrates(entity))
      .unwrap()
      .then(() => {
        Swal.fire("Record Updated", "", "success").then(() => {
          navigate(`/LeaveProratedForm/${id}?page=${page}&years=${years}`);
        });
      })
      .catch((err) => {
        Swal.fire("Error", err.message, "error");
      });
  };      
  
  const handleBtnBack = () => {
    dispatch(resetList());
    navigate(`/LeaveProratedList?page=${page}&years=${years}`);
  };

  return (
    <Container className="ContainerContent">
      {loading && (
        <ThreeDots
          visible={loading}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent2">

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>

        <h1 className="TitleHeader">Leave Prorates {years}</h1>
        <h1 className="MiniTitleHeader">Employee</h1>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">FullName</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={proratesList.employee?.fullname} readOnly disabled/>
              </Col>
            </Row>
          </Col>
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Date Joined</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={moment(proratesList.employee?.date_joined).format("YYYY-MM-DD")} readOnly disabled />
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Staff ID</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={proratesList.employee?.sid} readOnly disabled/>
              </Col>
            </Row>
          </Col>
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Company</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={proratesList.employee?.company?.description} readOnly disabled/>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Employee Category</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={proratesList.employee?.employee_category?.description} readOnly disabled />
              </Col>
            </Row>
          </Col>
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Service Length</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control value={proratesList.employee?.service_length?.description} readOnly disabled/>
              </Col>
            </Row>
          </Col>
        </Row>
        
        {/* <Row className="my-3">
          <Col md={4} sm={4}>
            <Form.Label className="FormLabel fw-normal fs-5">Prorate Date</Form.Label>
          </Col>
          <Col md={8} sm={8}>
            {!id ? (
              <Form.Control type="date" name="prorate_date" value={moment(prorate_date).format("YYYY-MM-DD")} onChange={handleUpdate}/>
            ) : (
              <Form.Control value={moment(prorate_date).format("YYYY-MM-DD")} readOnly />
            )}
          </Col>
        </Row> */}

        <hr className="hr-white" />

        {[
          { label: "Leave Brought Forward", name: "leave_bf", value: leave_bf },
          // { label: "Leave Awarded", name: "leave_awarded_this_year", value: leave_awarded_this_year },
          // { label: "Sick Leave Awarded", name: "sickleave_awarded_this_year", value: sickleave_awarded_this_year },
          // { label: "Medical Benefit Awarded", name: "medicalbenefit_awarded_this_year", value: medicalbenefit_awarded_this_year },
          { label: "Leave Taken", name: "leave_taken_this_year", value: leave_taken_this_year },
          { label: "Current Leave Balance", name: "current_leave_balance", value: current_leave_balance },
        ].map((field, index) => (
          <Row className="my-3" key={index}>
            <Col md={4} sm={4}>
              <Form.Label className="FormLabel fw-normal fs-5">{field.label}</Form.Label>
            </Col>
            <Col md={8} sm={8}>
              <Form.Control type="number" name={field.name} value={field.value} readOnly disabled/>
            </Col>
          </Row>
        ))}

        <hr className="hr-white" />

        {/* <Row className="my-3">
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Prorate Date</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control
                  value={moment(prorate_date).format("YYYY-MM-DD")}
                  readOnly
                />
              </Col>
            </Row>
          </Col>
          <Col md={6} sm={6}>
            <Row>
              <Col md={4} sm={4}>
                <Form.Label className="FormLabel fw-normal fs-5">Prorated Type</Form.Label>
              </Col>
              <Col md={8} sm={8}>
                <Form.Control
                  name="prorate_type"
                  value={prorate_type === -1 ? "Resign" : "Join"}
                  readOnly
                />
              </Col>
            </Row>
          </Col>
        </Row> */}

        <Row className="my-3">
          <Col xs={12} md={2} sm={2}>
            <Form.Label className="FormLabel fw-normal fs-5">Prorate Date & Type</Form.Label>
          </Col>

          <Col xs={6} md={5} sm={5} className="d-flex align-items-center justify-content-center">
            <Form.Control
              value={moment(created).format("YYYY-MM-DD")}
              readOnly
              disabled
            />
          </Col>

          <Col xs={6} md={5} sm={5} className="d-flex align-items-center justify-content-center">
            <Form.Control
              name="prorate_type"
              value={prorate_type === -1 ? "Resign" : "Join"}
              readOnly
              disabled
            />
          </Col>
        </Row>

        {/* {[
          {
            label: `Annual Awarded`,
            // label: "Prorated Leave",
            name: "prorated_leave_awarded",
            value: prorated_leave_awarded,
            value2: awardList.annual
          },
          {
            label: `Sick Awarded`,
            // label: "Prorated Sick Leave",
            name: "prorated_sickleave_awarded",
            value: prorated_sickleave_awarded,
            value2: awardList.sick
          },
          {
            label: `Medical Awarded`,
            // label: "Prorated Medical Benefit",
            name: "prorated_medicalbenefit_awarded",
            value: prorated_medicalbenefit_awarded,
            value2: awardList.medical
          }
        ].map((field, index) => (
          <Row className="my-3" key={index}>
            <Col md={6} sm={6}>
              <Row>
                <Col md={4} sm={4}>
                  <Form.Label className="FormLabel fw-normal fs-5">{field.label}</Form.Label>
                </Col>
                <Col md={8} sm={8}>
                  <Form.Control
                    value={field.value2}
                    readOnly
                  />
                </Col>
              </Row>
            </Col>
            
            <Col md={6} sm={6}>
              <Row>
                <Col md={4} sm={4}>
                  <Form.Label className="FormLabel fw-normal fs-5">Entitled</Form.Label>
                </Col>
                <Col md={8} sm={8}>
                  <Form.Control
                    type="number"
                    min="0"
                    name={field.name}
                    value={Math.abs(field.value).toFixed(1) || 0.0}
                    onChange={handleUpdateProrated}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        ))} */}

        <br></br>

        <Row>
          <Col xs={12} md={2} sm={2}>
            {/* <Form.Label className="FormLabel fw-normal fs-5"></Form.Label> */}
          </Col>

          <Col xs={6} md={5} sm={5} className="d-flex align-items-center justify-content-center">
            <Form.Label className="FormLabel fw-normal fs-5">Awarded</Form.Label>
          </Col>

          <Col xs={6} md={5} sm={5} className="d-flex align-items-center justify-content-center">
            <Form.Label className="FormLabel fw-normal fs-5">Entitled</Form.Label>
          </Col>
        </Row>

        {[
          {
            label: `Annual Leave`,
            name: "prorated_leave_awarded",
            value: prorated_leave_awarded,
            value2: awardList.annual
          },
          {
            label: `Sick Leave`,
            name: "prorated_sickleave_awarded",
            value: prorated_sickleave_awarded,
            value2: awardList.sick
          },
          {
            label: `Medical Benefit`,
            name: "prorated_medicalbenefit_awarded",
            value: prorated_medicalbenefit_awarded,
            value2: awardList.medical
          }
        ].map((field, index) => (
          <Row className="my-3" key={index}>
            <Col xs={12} md={2} sm={2}>
              <Form.Label className="FormLabel fw-normal fs-5">{field.label}</Form.Label>
            </Col>

            <Col xs={6} md={5} sm={5}>
              <Form.Control
                value={Number(field.value2).toFixed(1)}
                readOnly disabled
              />
            </Col>

            <Col xs={6} md={5} sm={5}>
              <Form.Control
                type="number"
                min="0"
                name={field.name}
                value={Math.abs(field.value).toFixed(1) || 0.0}
                onChange={handleUpdateProrated}
              />
            </Col>
          </Row>
        ))}

        <Row className="my-3">
          <p style={{ color: 'yellow', fontSize: '1.1rem' }}>
            Entitled = Leave balance after deductions (e.g. Leave Awarded - Leave Deductions)
          </p>
        </Row>

        {/* {[
          {
            label: `Leave Entitle (Award this year = ${awardList.annual})`,
            // label: "Prorated Leave",
            name: "prorated_leave_awarded",
            value: prorated_leave_awarded,
          },
          {
            label: `Sick Leave Entitle (Award this year = ${awardList.sick})`,
            // label: "Prorated Sick Leave",
            name: "prorated_sickleave_awarded",
            value: prorated_sickleave_awarded,
          },
          {
            label: `Medical Benefit Entitle (Award this year = ${awardList.medical})`,
            // label: "Prorated Medical Benefit",
            name: "prorated_medicalbenefit_awarded",
            value: prorated_medicalbenefit_awarded,
          }
        ].map((field, index) => (
          <Row className="my-3" key={index}>
            <Col md={4} sm={4}>
              <Form.Label className="FormLabel fw-normal fs-5">{field.label}</Form.Label>
            </Col>
            <Col md={8} sm={8}>
              <Form.Control
                type="number"
                min="0"
                name={field.name}
                value={Math.abs(field.value).toFixed(1) || 0.0}
                onChange={handleUpdateProrated}
              />
            </Col>
          </Row>
        ))} */}

        {/* {[
          { label: "New Leave Balance", name: "new_leave_balance", value: new_leave_balance },
          { label: "Deduction Required", name: "deduction_required", value: deduction_required },
        ].map((field, index) => (
          <Row className="my-3" key={index}>
            <Col md={2} sm={2}>
              <Form.Label className="FormLabel fw-normal fs-5">{field.label}</Form.Label>
            </Col>
            <Col md={10} sm={10}>
              <Form.Control type="number" name={field.name} value={Math.abs(field.value).toFixed(1) || 0.0} onChange={handleUpdate} readOnly/>
            </Col>
          </Row>
        ))} */}

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
          &nbsp; &nbsp;
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnUpdate}>
              Update
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </Container>
  );
};

export default LeaveProratedForm;